module.exports = __webpack_public_path__ + "media/images/layouts/u_shape-5ad73379c26f6edf3ac4955e6bbecb28.png";